import { io } from 'socket.io-client';

// const URL = process.env.NODE_ENV === 'production' 
const socketUrl = process.env.REACT_APP_SOCKET_ENDPOINT;

export const socket = io(socketUrl, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});